import { Loader2 } from "lucide-react";

export default function LayeredEditLoading() {
  return <div role="status" className="flex flex-col items-center gap-3 py-8 text-center">
    <Loader2 className="h-6 w-6 animate-spin text-primary" aria-hidden="true" />
    <p className="text-sm text-muted-foreground">This may take a few minutes.</p>
  </div>;
}
